var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import parser from 'html-react-parser';
import './TwoColumnsIframeImage.scss';
export default function TwoColumnsIframe(_a) {
    var _b = _a.sectionName, sectionName = _b === void 0 ? 'baseIframe' : _b, props = __rest(_a, ["sectionName"]);
    var _c = props.data, title = _c.title, titleTag = _c.titleTag, iframe = _c.iframe, oneColumn = _c.oneColumn, headline = _c.headline, body = _c.body, orientation = _c.orientation, imageSrc = _c.imageSrc, imageAlt = _c.imageAlt;
    var isImageToShow = !body && !headline && imageSrc && !oneColumn;
    return (_jsxs("div", __assign({ id: "iframeContactUs", className: sectionName + " iframe-col--container " + (isImageToShow ? 'iframe-col--container-iframe-image' : '') + " " + (orientation === 'left' ? 'iframe-col--container-reverse' : '') + " " + (oneColumn ? 'iframe-col--container-one-col' : '') + " " }, { children: [_jsxs("div", __assign({ className: "iframe-col--container-iframe" }, { children: [titleTag == 'h1' && (_jsx("h1", __assign({ className: "iframe-col--container-title" }, { children: title }), void 0)),
                    titleTag == 'h2' && (_jsx("h2", __assign({ className: "iframe-col--container-title" }, { children: title }), void 0)),
                    _jsx("p", __assign({ className: "iframe-col--title-sub-text" }, { children: "* Required Field" }), void 0),
                    iframe && (_jsx("div", __assign({ className: "flex-col iframe-col--wrapper" }, { children: parser(iframe) }), void 0))] }), void 0),
            !isImageToShow && !oneColumn && (_jsxs("div", __assign({ className: "iframe-col--container-text" }, { children: [headline && (_jsx("p", __assign({ className: "iframe-col--container-text-title" }, { children: headline }), void 0)),
                    body && (_jsx("div", __assign({ className: "iframe-col--container-text-description" }, { children: parser(body) }), void 0))] }), void 0)),
            isImageToShow && !oneColumn && (_jsx("div", __assign({ className: "iframe-col--container-image" }, { children: _jsx("img", { src: imageSrc, alt: imageAlt }, void 0) }), void 0))] }), void 0));
}
